import React, { useState, useEffect } from 'react';
import { Form, Button, Grid } from 'semantic-ui-react';

interface AdditiveFormProps {
  additive?: {
    id: number;
    name: string;
    description: string;
  } | null;
  onSubmit: (data: { name: string; description: string }) => void;
  onCancel: () => void;
}

export function AdditiveForm({ additive, onSubmit, onCancel }: AdditiveFormProps) {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
  });

  useEffect(() => {
    if (additive) {
      setFormData({
        name: additive.name,
        description: additive.description || '',
      });
    }
  }, [additive]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Grid stackable columns={2}>
        <Grid.Column width={16}>
          <Form.Field>
            <label>Name</label>
            <Form.Input
              placeholder="Additive name"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              required
            />
          </Form.Field>
          <Form.Field>
            <label>Description</label>
            <Form.TextArea
              placeholder="Add any notes about this additive"
              value={formData.description}
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
            />
          </Form.Field>
        </Grid.Column>
      </Grid>
      <Form.Group>
        <Button type="button" onClick={onCancel}>
          Cancel
        </Button>
        <Button type="submit" primary>
          {additive ? 'Update' : 'Create'}
        </Button>
      </Form.Group>
    </Form>
  );
}

